import { Box, Typography, Button } from '@mui/material';
import React from 'react';
import landingImage from '../../assets/landing/banner_bg.jpg'; // Import the background image

const MainBanner = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        backgroundImage: `url(${landingImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        textAlign: 'center',
      }}
    >
      {/* Dark Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)', // Adjust opacity as needed
          zIndex: 1,
        }}
      />

      {/* Content on top of the overlay */}
      <Box sx={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>
        {/* Banner Text */}
        <Typography variant="h2" sx={{ fontWeight: 'bold', mb: 2 }}>
          THE RIGHT WAY TO DREAMLAND
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 4 }}>
        At Sky Europe, we connect you with global opportunities in hotels, construction, caregiving, and more. Trusted by <br/>professionals, powered by a dedicated team. Contact us today to start your journey!
        </Typography>

        {/* Centered Action Buttons */}
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          {/* <Button variant="contained" sx={{ padding: '20px 20px', backgroundColor:'#ffffff', color:'#252525', fontFamily:'sans-serif', fontWeight:'500' }}>
            Apply Now
          </Button> */}
          <Button href="tel:+94765508787"  variant="contained" sx={{ padding: '20px 20px', backgroundColor:'#ff6600', color:'#ffffff', fontFamily:'sans-serif', fontWeight:'500' }}>
            Schedule Quick Call
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default MainBanner;
